<template>
    <div class="last-customer-orders-list">
        <ErrorsZone :errors="errors" />

        <div v-if="loading">
            <i class="fad fa-spinner fa-spin"></i> Chargement des dernières commandes du client...
        </div>
        <div v-else-if="hasOrders">
            <label for="old-order-select">Sélectionner une commande</label>
            <select class="form-control" id="old-order-select" @change="onSelectOrder">
                <option :value="null">Sélectionner...</option>
                <option v-for="order in orders" :value="order.id">
                    Livraison du {{ global.moment(order.delivery_date).format('dddd Do MMMM YYYY') }}
                </option>
            </select>
        </div>
        <div v-else class="alert alert-info">
            Aucune commande
        </div>
    </div>
</template>

<script>
    import ErrorsZone from "./ErrorsZone"

    import {useGetLoader} from "./compositions/axios/loadingRequest";

    export default {
        name: 'LastCustomerOrdersList',

        components: {
            ErrorsZone,
        },

        setup() {
            const {
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loading,
                errors,
                load,
            };
        },

        props: {
            customer: {
                type: Object,
                required: true,
            },
            previousOrdersAction: {
                type: String,
                required: false,
            },
        },

        data() {
            return {
                orders: [],
            };
        },

        mounted() {
            this.loadLastCustomerOrders();
        },

        watch: {
            customer() {
                this.loadLastCustomerOrders();
            },
        },

        computed: {
            hasOrders() {
                return this.orders && this.orders.length;
            },
        },

        methods: {
            onSelectOrder(event) {
                const orderId = event.target.value;

                if (orderId) {
                    const order = this.orders.find(item => item.id == orderId);

                    if (order) {
                        this.$emit('selected', order);
                        return;
                    }
                }

                this.$emit('selected', null);
            },

            async loadLastCustomerOrders() {
                this.orders = [];

                if(this.customer) {
                    let url = `/espace-employes/commandes/liste-dernieres-commandes/client/${this.customer.id}`;
                    if(this.previousOrdersAction) {
                        url = this.previousOrdersAction;
                    }
                    const response = await this.load(url);

                    if (response && response.orders) {
                        this.orders = response.orders;
                    }
                }
            },
        },
    }
</script>
